import { render } from "./location-header.vue?vue&type=template&id=c381c68e"
import script from "./location-header.vue?vue&type=script&lang=js"
export * from "./location-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__